import { useEffect } from 'react'

const isEditableTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  return target.isContentEditable
}

interface UseCommandPaletteHotkeysOptions {
  open: boolean
  onOpen: (seed?: string) => void
  onToggle: () => void
}

export function useCommandPaletteHotkeys({
  open,
  onOpen,
  onToggle,
}: UseCommandPaletteHotkeysOptions) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const isModK = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k'
      if (isModK) {
        event.preventDefault()
        onToggle()
        return
      }

      if (open) return
      if (event.key !== '/') return
      if (event.metaKey || event.ctrlKey || event.altKey) return
      if (isEditableTarget(event.target)) return

      event.preventDefault()
      onOpen('/')
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [open, onOpen, onToggle])
}
